import React from "react";
import PropTypes from "prop-types";
import { ColoredPill } from "../../../../../../components/atoms";

const AmpColumn = ({ amp }) => {
  const value = amp && amp.split(" - ")[0].trim(" ");
  if (value) {
    return (
      <ColoredPill
        saphClass="saph-pill saph-pill-amp"
        colorParams={{
          type: "tier",
          value,
        }}
        content={<div className="tw-text-sm">{amp}</div>}
      />
    );
  }
  return "-";
};

AmpColumn.propTypes = {
  amp: PropTypes.string,
};

AmpColumn.defaultProps = {
  amp: "",
};

export default AmpColumn;
